// extracted by mini-css-extract-plugin
module.exports = {"mainloader":"main-loader_mainloader__s7tjD","min_height_50":"main-loader_min_height_50__AEDzh","full_height":"main-loader_full_height__0Cc9q"};